import axios from "axios";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });
api.defaults.headers.common["X-VTZ-App"] = "1";

api.interceptors.request.use((config) => {
  const cid = localStorage.getItem("vtz_company");
  if (cid) config.headers["X-Company-Id"] = cid;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/")) {
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const FX_RATE = 1.9558;

export const fmtNum = (n, cur = "") => {
  const s = new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);
  return cur ? `${s} ${cur}` : s;
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}.${m}.${y}.`;
};

export const daysLate = (iso) => Math.max(0, Math.floor((Date.now() - new Date(iso + "T00:00:00Z").getTime()) / 86400000));

export default api;
